import React, { useState, useEffect } from "react";
import classnames from "classnames";
import Validator from "validator";
import { Stats } from "./Stats"
import { getCountries } from "../../actions/countriesActions";
import { getZipCode } from "../../actions/zipcodeActions";
import materialize from "materialize-css"

export const ExpressInformation = (props) => {

    const [errorEmail, setErrorEmail] = useState('');
    const [errorNombre, setErrorNombre] = useState('');
    const [errorApellido, setErrorApellido] = useState('');
    
    const [errorNombreEmpresa, setErrorNombreEmpresa] = useState('');
    const [errorGiroOtros, setErrorGiroOtros] = useState('');

    const [errorCiudad, setErrorCiudad] = useState('');
    const [errorCodigoPostal, setErrorCodigoPostal] = useState('');
    
    const [errorPais, setErrorPais] = useState('');
    const [countries, setCountries] = useState([]);


    useEffect(() => {

        getCountries()
            .then(response => {
                let countries = [];
                countries = response.data.map((country) => {
                    return <option key={country.iso2} value={country.iso2}>{country.name}</option>
                });

                setCountries(countries);
                materialize.AutoInit();
                materialize.updateTextFields();
            });
    }, []);


    const update = (e) => {
        props.update(e.target.id, e.target.value);
    };


    const submit = async () => {

        let valid = true;
        let language = localStorage.getItem("exmi_language");

        // Errors clean up
        setErrorEmail("");
        setErrorNombre("");
        setErrorApellido("");

        setErrorNombreEmpresa("");
        setErrorGiroOtros("");


        setErrorCiudad("");
        setErrorCodigoPostal("");

        setErrorPais("");



        if (language === "es") {
            // Email checks
            if (Validator.isEmpty(props.form.email)) {
                setErrorEmail("Email es requerido");
                valid = false;
            } else if (!Validator.isEmail(props.form.email)) {
                setErrorEmail("Email es invalido");
                valid = false;
            }

            // Nombres
            if (Validator.isEmpty(props.form.nombres)) {
                setErrorNombre("Nombre es requerido");
                valid = false;
            }

            // Apellidos
            if (Validator.isEmpty(props.form.apellidos)) {
                setErrorApellido("Apellido es requerido");
                valid = false;
            }




            // Ciudad
            if (props.form.pais !== "MX" && props.form.pais !== "US") {
                if (Validator.isEmpty(props.form.ciudad)) {
                    setErrorCiudad("Ciudad es requerida");
                    valid = false;
                }
            }

            // Pais
            if (Validator.isEmpty(props.form.pais)) {
                setErrorPais("Pais es requerido");
                valid = false;
            }

            // Código Postal
            if (Validator.isEmpty(props.form.codigoPostal)) {
                setErrorCodigoPostal("Código Postal es requerido");
                valid = false;
            } else if (props.form.pais === "MX" || props.form.pais === "US") {

                if (!Validator.isInt(props.form.codigoPostal)) {
                    setErrorCodigoPostal("Código Postal invalido, debe ser numérico");
                    valid = false;
                }
                else {
                    await getZipCode(props.form.pais, props.form.codigoPostal)
                        .then(response => {

                            if (response.data === null) {
                                setErrorCodigoPostal("Código Postal invalido");
                                props.update("estado", "");
                                props.update("ciudad", "");
                                valid = false;
                            }
                            else {
                                props.update("estado", response.data.stateName);
                                props.update("ciudad", response.data.city);
                            }
                        });
                }
            }

        }
        else {
            // Email checks
            if (Validator.isEmpty(props.form.email)) {
                setErrorEmail("Email is Required");
                valid = false;
            } else if (!Validator.isEmail(props.form.email)) {
                setErrorEmail("Email is Invalid");
                valid = false;
            }

            // Nombres
            if (Validator.isEmpty(props.form.nombres)) {
                setErrorNombre("First Name is Required");
                valid = false;
            }

            // Apellidos
            if (Validator.isEmpty(props.form.apellidos)) {
                setErrorApellido("Last Name is Required");
                valid = false;
            }

            // Ciudad
            if (props.form.pais !== "MX" && props.form.pais !== "US") {
                if (Validator.isEmpty(props.form.ciudad)) {
                    setErrorCiudad("City is Required");
                    valid = false;
                }
            }

            // Pais
            if (Validator.isEmpty(props.form.pais)) {
                setErrorPais("Country is Required");
                valid = false;
            }

            // Código Postal
            if (Validator.isEmpty(props.form.codigoPostal)) {
                setErrorCodigoPostal("Zip Code is Required");
                valid = false;
            } else if (props.form.pais === "MX" || props.form.pais === "US") {

                if (!Validator.isInt(props.form.codigoPostal)) {
                    setErrorCodigoPostal("Zip Code is Invalid, it must be numeric");
                    valid = false;
                }
                else {
                    await getZipCode(props.form.pais, props.form.codigoPostal)
                        .then(response => {

                            if (response.data === null) {
                                setErrorCodigoPostal("Zip Code is Invalid");
                                props.update("estado", "");
                                props.update("ciudad", "");
                                valid = false;
                            }
                            else {
                                props.update("estado", response.data.stateName);
                                props.update("ciudad", response.data.city);
                            }
                        });
                }
            }
        }

        if (valid)
            props.submit();
    };

    return (
        <div>
            <div className="input-field col s12">
                <input
                    disabled
                    placeholder=""
                    onChange={update}
                    value={props.form.email}
                    error={errorEmail}
                    id="email"
                    type="email"
                     className={classnames("font-face-msb", {
                        invalid: errorEmail
                    })}
                />
                <label htmlFor="email" className="active">{props.locale.dashboard_comprador_label_mail}</label>
                <span className="red-text">{errorEmail}</span>
            </div>
            <div className="input-field col s12 m6 l6">
                <input
                    onChange={update}
                    value={props.form.nombres}
                    error={errorNombre}
                    id="nombres"
                    type="text"
                     className={classnames("font-face-msb", {
                        invalid: errorNombre
                    })}
                />
                <label htmlFor="nombres">{props.locale.dashboard_comprador_label_name}</label>
                <span className="red-text">{errorNombre}</span>
            </div>
            <div className="input-field col s12 m6 l6">
                <input
                    onChange={update}
                    value={props.form.apellidos}
                    error={errorApellido}
                    id="apellidos"
                    type="text"
                     className={classnames("font-face-msb", {
                        invalid: errorApellido
                    })}
                />
                <label htmlFor="apellidos">{props.locale.dashboard_comprador_label_lastname}</label>
                <span className="red-text">{errorApellido}</span>
            </div>



            <div className="input-field col s12 m6 l6">
              <input
                onChange={update}
                value={props.form.nombreEmpresa}
                error={errorNombreEmpresa}
                id="nombreEmpresa"
                type="text"
                 className={classnames("font-face-msb", {
                  invalid: errorNombreEmpresa
                })}
              />
              <label htmlFor="nombreEmpresa">{props.locale.express_comprador_label_nameofcompany_member}</label>
              <span className="red-text">{errorNombreEmpresa}</span>
            </div>

            <div className="input-field col s12 m6 l6">
                <input
                    onChange={update}
                    value={props.form.giroOtros}
                    error={errorGiroOtros}
                    id="giroOtros"
                    type="text"
                     className={classnames("font-face-msb", {
                        invalid: errorGiroOtros
                    })}
                />
                <label htmlFor="giroOtros">{props.locale.express_comprador_label_type_business}</label>
                <span className="red-text">{errorGiroOtros}</span>
            </div>

            <div className="input-field col s12 m6 l6">
                <select value={props.form.pais} onChange={update} id="pais" className="select">
                    <option value="" disabled>
                        {props.locale.dashboard_comprador_label_country}
                    </option>
                    {countries}
                </select>
                <label>{props.locale.dashboard_comprador_label_country_select}</label>
                <span className="red-text">{errorPais}</span>
            </div>
            {(props.form.pais !== "MX" && props.form.pais !== "US") ?
                <>
                    <div className="input-field col s12 m6 l6">
                        <input
                            onChange={update}
                            value={props.form.ciudad}
                            error={errorCiudad}
                            id="ciudad"
                            type="text"
                             className={classnames("font-face-msb", {
                                invalid: errorCiudad
                            })}
                        />
                        <label htmlFor="ciudad">{props.locale.dashboard_comprador_label_city}</label>
                        <span className="red-text">{errorCiudad}</span>
                    </div>
                </> :
                <></>
            }
            <div className="input-field col s12 m6 l6">
                <input
                    onChange={update}
                    value={props.form.codigoPostal}
                    error={errorCodigoPostal}
                    id="codigoPostal"
                    type="text"
                     className={classnames("font-face-msb", {
                        invalid: errorCodigoPostal
                    })}
                />
                <label htmlFor="codigoPostal">{props.locale.dashboard_comprador_label_zipcode}</label>
                <span className="red-text">{errorCodigoPostal}</span>
            </div>
    


            <Stats step={2} {...props} nextStep={submit} locale={props.locale} disableSubmit={props.disableSubmit} />
        </div>

    );
};
